import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

export function getMuiTab(_theme: Theme): MuiThemeComponentOverride<"MuiTab"> {
  return {
    MuiTab: {
      styleOverrides: { root: { marginRight: "16px", minWidth: 0, padding: "12px 16px 12px 0" } },
    },
  };
}
